import { RollupApi } from '@business/api/tm_rollup';
import { RollupId, TmRollupResponse } from '@business/entities/tm/TmRollupResponse';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap, tap } from 'rxjs/operators';

export class RollupBloc extends BaseBloc {
  private readonly tmRollupsRepo = new Repository<TmRollupResponse>({
    getItemId: term => term.id,
  });

  readonly rollups$ = this.tmRollupsRepo.items$;
  readonly selectTemplate = this.tmRollupsRepo.selectItem;

  onReset() {
    this.tmRollupsRepo.reset();
  }

  fetchRollups = () => {
    return RollupApi.fetchRollups().pipe(this.tmRollupsRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_region_error') }));
  };

  fetchRollup = (id: RollupId) => {
    return RollupApi.fetchRollup(id).pipe(
      this.tmRollupsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_region_error') }),
    );
  };

  createRollup = (data: Partial<TmRollupResponse>) => {
    return RollupApi.createRollup(data).pipe(
      this.tmRollupsRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_region'),
      }),
    );
  };

  updateRollup = (id: RollupId, data: Partial<TmRollupResponse>) => {
    return RollupApi.updateRollup(id, data).pipe(
      this.tmRollupsRepo.ops.upsertOne(item => ({ item })),
      tap(() => this.fetchRollups().subscribe()),
      handleMessage({
        type: requestMessage('update_region'),
      }),
    );
  };

  deleteRollup = (id: RollupId) => {
    return showDeleteConfirmation('Delete Term', `Do you really want to remove this term?`).pipe(
      switchMap(() => RollupApi.deleteRollup(id)),
      this.tmRollupsRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_region'),
      }),
    );
  };
}
